import { Icon, IconProps } from "../";

export const DropupIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.34519 13.7284C7.53866 14.1954 7.99446 14.5 8.50004 14.5H15.5C16.0056 14.5 16.4614 14.1954 16.6549 13.7284C16.8484 13.2613 16.7414 12.7236 16.3839 12.3661L12.8839 8.86612C12.3958 8.37796 11.6043 8.37796 11.1162 8.86612L7.61615 12.3661C7.25866 12.7236 7.15171 13.2613 7.34519 13.7284Z"
      />
    </Icon>
  );
};
